import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

interface getStarshipITDailyManifestationOrdersInterface {
  take?: number
  skip?: number
  principle?: any
  courier?: any
  orderStartDate?: string
  orderEndDate?: string
  consignmentStarDate?: string
  consignmentEndDate?: string
  manifestStatus?: any
}

export const useGetStarshipITDailyManifestationOrders = () => {
  const mutate = useMutation(
    ({
      take,
      skip,
      principle,
      courier,
      orderStartDate,
      orderEndDate,
      consignmentStarDate,
      consignmentEndDate,
      manifestStatus,
    }: getStarshipITDailyManifestationOrdersInterface) => {
      return get(
        `/StarshipITReports/DailyManifestationOrder?Take=${take}&Skip=${skip}&Principle=${
          principle?.value === 'All' ? '' : principle?.value
        }&SubCourier=${
          courier?.value === 'All' ? '' : courier?.value
        }&OrderDateFrom=${orderStartDate}&OrderDateTo=${orderEndDate}&ConsignmentDateFrom=${consignmentStarDate}&ConsignmentDateTo=${consignmentEndDate}&IsManifest=${
          manifestStatus?.value === 'All' ? '' : manifestStatus?.value
        }`,
      )
    },
  )

  return mutate
}

export default useGetStarshipITDailyManifestationOrders
